<template>
    <v-dialog v-model="dialogShowStatus" hide-overlay max-width="800">
        <v-form ref="form" @submit.prevent="confirm">
            <v-card class="window-card">
                <div class="d-flex align-end mb-3">
                    <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
                        <v-icon color="white"> mdi-bookmark </v-icon>
                    </v-card>
                    <span class="h4 ml-1 mb-n1">任务步骤信息</span>
                </div>
                <v-form v-model="valid" class="px-10">
                    <v-select v-model="formData.type" :items="tabType" item-text="label" item-value="value" label="类型"
                        :rules="[v => !!v || '类型不能为空']"></v-select>
                    <SceneMetaTab v-if="formData.type == 'editor'" ref="editor" />
                    <SystemMetaTab v-if="formData.type == 'system'" ref="system" />
                    <v-text-field v-model="formData.stepTime" label="步骤时间 *" type="number"
                        :rules="[v => !!v || '步骤时间不能为空']" hint="请使用整数类型，单位秒（s）"></v-text-field>
                    <v-text-field v-model="formData.stepOrder" type="number" label="步骤顺序"
                        hint="请使用阿拉伯数字"></v-text-field>
                </v-form>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="handelConfirm">确 定</v-btn>
                    <v-btn color="gray" @click.stop="dialogShowStatus = false">取 消</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>
<script>
import { Tabs, NavTabsCard } from '@/components'
import SystemMetaTab from '../Tab/SystemMetaTab'
import SceneMetaTab from '../Tab/SceneMetaTab'
import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { tabType } from './TabType'
extend('required', required)
import { mapGetters } from 'vuex'

export default {
    props: {
        showExtDialog: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            formData: {
                type: 'editor'
            },
            tab: '',
            valid: false,
            tabType
        }
    },
    computed: {
        ...mapGetters(['stepForm']),
        dialogShowStatus: {
            get() {
                this.formData = {
                    type: 'editor'
                }
                return this.showExtDialog;
            },
            set(val) {
                this.$emit('update:showExtDialog', val)
            }
        }
    },
    methods: {
        init(form) {
            let that = this;
            that.formData = {}
            that.formData = Object.assign({
                type: 'editor'
            }, this.stepForm);
            that.$nextTick(() => {
                that.$refs[that.formData.type].init(that.formData ?? {})
            })
        },
        tabChange(e) {
            this.tab = e
        },
        handelConfirm() {
            const { type, stepTime, stepOrder } = this.formData
            let subObj = Object.assign({}, this.$refs[type].form);
            Object.assign(subObj, { stepTime, stepOrder, type });

            this.$emit('confirm', subObj)
        }
    },
    components: {
        Tabs,
        NavTabsCard,
        SystemMetaTab,
        SceneMetaTab,
    }
}
</script>
<style>
.window-card {
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>